import $ from 'jquery'

export default {
    name: 'ajout-fournisseur',
    components: {},
    props: [],
    data () {
      return {
          loading: false,
          nom: null,
          contact: null,
          adresse: null,
          check: true,
      }
    },
    computed: {

    },
  
    mounted () {
        setTimeout(() => {
            $('.p-content').fadeIn();
        }, 500);
    },
    methods: {

          async submitForm() {

            const isValid = await this.$refs.observer.validate();
            if (!isValid) {
                console.log('error')
            } else {
                this.loading=true;

                const data = {
                    nom:  this.nom,
                    telephone: this.contact,
                    adresse: this.adresse,
                }   
                this.$store.dispatch("saveFournisseur",data).then(
                    response => {
                        if (response) {
                            this.$router.push({ path: `/fournisseurs` }) 
                        } 
                    }
                );

                this.loading=false;

            }

      
          },
  
  
    }
  }
  
  
  